webpackJsonp([169109190802891],{

/***/ 1756:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"DetailedSalesRevenueItemConnection","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"edges","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"DetailedSalesRevenueItemEdge","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"pageInfo","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"OBJECT","name":"PageInfo","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-detailed-sales-revenue-item-connection-e9298dd923e3f6ccbe12.js